module.exports = __webpack_public_path__ + "img/master-visaul.d30c993d.png";